import React, { useState } from 'react';
import { HiMenu, HiOutlineX } from 'react-icons/hi';

import logo from '../../assets/logo.png';
import './navbar.css';

const Menu = () => (
  <>
  <p><a href='#tentang'>Tentang</a></p>
  <p><a href='#layanan'>Layanan</a></p>
  <p><a href='#apps'>Apps</a></p>
  <p><a href='#contact'>Hubungi Kami</a></p>
  </>
)


const Navbar = () => {
  
  const [toggleMenu, setToggleMenu] = useState(false);
  
  return (
    <div className='pl__navbar'>
      <div className='pl__navbar-links_logo'>
        <img src={logo} alt="Logo Pantja Laundry" />
      </div>
      <div className='pl__navbar-links'>
        <div className='pl__navbar-links_container'>
          <Menu />
        </div>
      </div>
      <div className="pl__navbar-menu">
        {toggleMenu
        // Declare If Variable for Mobile Menu
         ? <HiOutlineX color='#082044' id='openUp' size={27} onClick={() => setToggleMenu(false)} />
         : <HiMenu color='#fff' size={27} onClick={() => setToggleMenu(true)} />
        }
        {/* On Below : Only if variable is true, only then render what is coming */}
        {toggleMenu && (
          // And what's coming is div on below
          <div className="pl__navbar-menu_container scale-up-center">
            <div className="pl__navbar-menu_container-links">
              {/* Call the wrapped menu. LOL! XD */}
              <Menu />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Navbar